// extracted by mini-css-extract-plugin
export default {"cls1":"CreateComment-cls1_FmZ","cls2":"CreateComment-cls2_W9D CreateComment-cls1_FmZ"};